module.exports = "<div class=\"card-request-success\">\n  <i class=\"icon icon-cross\" ng-click=\"$ctrl.onClose()\"></i>\n  <i class=\"icon icon-confirmation\"></i>\n  <p ng-if=\"!$ctrl.withoutManager\">{{'FOOD_BENEFIT.CARD_REQUEST_SUCCESS.MESSAGE' | translate}}</p>\n  <p ng-if=\"$ctrl.withoutManager\">{{'FOOD_BENEFIT.CARD_REQUEST_SUCCESS.MESSAGE_WITHOUT_MANAGER' | translate}}</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardRequestSuccess/cardRequestSuccess.html
// module id = 1610
// module chunks = 0